import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * 案件質問回答表示 コンポーネント
 */
export const RfpProfessionalQuestionAnswer = (props) => {
    const { answer = '', className = '', isAnswered, isEnd, isUnreadSelf } = props;
    const unansweredText = isEnd
        ? '回答なし（この案件の募集は終了しました）'
        : '回答待ち（ご担当者が確認しています）';
    return (_jsx(ColorPaper, Object.assign({ bgColor: isUnreadSelf ? 'emphasis' : 'lightGray', className: clsx('w-full', className) }, { children: _jsx(Text, Object.assign({ className: 'text-left whitespace-pre-line', color: isAnswered ? 'base' : 'textGray', size: 'sm' }, { children: isAnswered && !!answer ? answer : unansweredText })) })));
};
